function buildFooter() {
  if (
    $("#footer").length &&
    !$("body").is(".id--9, .id--16, .id--17")
  ) {
    $('.footer-bottom .copyright').html($('.footer-bottom .copyright').html().replace('Copyright ', 'Copyright 2016 - '))
    $('#footer .rating-section').insertBefore('#footer');
    $('#footer .ig-section').insertBefore('#footer');

    var $el = $('#footer .custom-footer__newsletter');
    $el.wrapInner('<div class="container"></div>');
    $el.insertBefore('#footer');

    $(".instagram-widget>a").each(function () {
      $(".ig-section .ig-feed").append('<div class="ig-post"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>')
    })
    $('#newsletterWidget').attr('placeholder', 'Vaše e-mailová adresa');
    $('.custom-footer__contact .contact-box ul li:nth-child(n+3)').appendTo('.social-reviews .social .wrap');
        if (!$('.contact-wrap .contact-box').length) {
            $('.custom-footer__contact .contact-box').clone().appendTo('.contact-wrap');
        }

    function rateSlider() {
    var $slider = $('.overall-wrapper > .rating-section .votes-wrap');

    if (!$slider.length) {
        return;
    }

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
    }

    if (!$slider.children('.vote-wrap').length) {
        return;
    }

    $slider.slick({
        slidesToShow: 3.9,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    infinite: false,
                    slidesToShow: 2.2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    infinite: false,
                    slidesToShow: 1.2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    infinite: false,
                    slidesToShow: 1.2
                }
            }
        ]
    });

    setTimeout(function () {
        $slider.slick('setPosition');
    }, 100);
}

function loadRatings() {
    var $target = $('.overall-wrapper > .rating-section .votes-wrap');

    if (!$target.length) {
        return;
    }

    $.ajax({
        url: '/cache/hodnoceni-obchodu/',
        type: 'GET',
        cache: false,

        success: function (ratingData) {
            var $tempDiv = $('<div>').html(ratingData);

            var $ratings = $tempDiv
                .find('.votes-wrap.simple-vote .vote-wrap')
                .filter(function () {
                    return $(this).find('.vote-content').text().trim().length >= 1;
                })
                .slice(0, 20)
                .clone();

            if (!$ratings.length) {
                console.warn('Nebyla nalezena žádná hodnocení.');
                return;
            }

            if ($target.hasClass('slick-initialized')) {
                $target.slick('unslick');
            }

            $target.empty().append($ratings);

            $target.find('.vote-header').each(function () {
                var $header = $(this);

                if ($header.next('.cloneMobile').length) {
                    return;
                }

                var name = $header.find('.vote-name').first().text().trim();
                var date = $header.find('.vote-time').first().text().trim();

                if (name.length) {
                    $('<div>', {
                        class: 'cloneMobile'
                    })
                    .append(
                        $('<span>', {
                            class: 'name',
                            text: name
                        })
                    )
                    .append(
                        $('<span>', {
                            class: 'time',
                            text: date
                        })
                    )
                    .insertAfter($header);
                }
            });

            requestAnimationFrame(function () {
                rateSlider();
            });
        },

        error: function (xhr, status, error) {
            console.error('Nepodařilo se načíst hodnocení:', status, error);
        }
    });
}

$(function () {
    loadRatings();
});

    $('.custom-footer > div:nth-child(-n+3)').each(function (index, element) {
      const block = $(element);
      const heading = block.find('h4');
      const list = block.find('ul');

      heading.on('click', function () {
        list.slideToggle(200);
        $(this).toggleClass('is-open');
      });
    });

    $(function () {

      const $lang = $('.lang');
      const $title = $lang.find('.lang-title');
      const $list = $lang.find('.lang-list');

      $title.on('click', function (e) {
        e.stopPropagation();
        $lang.toggleClass('is-open');
      });

      $(document).on('click', function () {
        $lang.removeClass('is-open');
      });

    });

  }
}


$(document).ready(function () {
  buildFooter();
});


$(document).on("click", ".display-results-group", function (event) {
    event.preventDefault();

    const $button = $(this);
    const $group = $button.closest(".search-results-group");
    const $list = $group.find(".search-results-group-list");

    $list.find("li.no-display").removeClass("no-display");
    $button.hide();
});